import { debounce } from "lodash-es";
function createBatchRequestWithCache(batchRequestFn, options = {}) {
  const { debounceDelay = 50, apiName = "\u6279\u91CF\u8BF7\u6C42\u63A5\u53E3" } = options;
  const promiseCache = new Map();
  let requestQueue = [];
  const pendingResolvers = new Map();
  const debouncedRequest = debounce(async () => {
    if (requestQueue.length === 0)
      return;
    const currentQueue = [...requestQueue];
    requestQueue = [];
    try {
      const response = await batchRequestFn(currentQueue);
      const responseData = (response == null ? void 0 : response.data) || [];
      if (responseData.length !== currentQueue.length) {
        currentQueue.forEach((param) => {
          const key = JSON.stringify(param);
          const resolver = pendingResolvers.get(key);
          if (resolver) {
            resolver.reject(new Error(`${apiName}\u53C2\u6570\u548C\u54CD\u5E94\u6570\u91CF\u4E0D\u4E00\u81F4\uFF0C\u53C2\u6570\uFF1A${JSON.stringify(currentQueue)}`));
            pendingResolvers.delete(key);
          }
        });
        return;
      }
      currentQueue.forEach((param, index) => {
        const key = JSON.stringify(param);
        const responseItem = responseData[index];
        const resolver = pendingResolvers.get(key);
        if (resolver) {
          resolver.resolve(responseItem);
          pendingResolvers.delete(key);
        }
      });
    } catch (error) {
      currentQueue.forEach((param) => {
        const key = JSON.stringify(param);
        const resolver = pendingResolvers.get(key);
        if (resolver) {
          resolver.reject(`\u63A5\u53E3\u8BF7\u6C42\u5931\u8D25\uFF1A${error}`);
          pendingResolvers.delete(key);
        }
      });
    }
  }, debounceDelay);
  return async function(params) {
    const promises = [];
    for (const param of params) {
      const key = JSON.stringify(param);
      if (promiseCache.has(key)) {
        const cachedPromise = promiseCache.get(key);
        promises.push(cachedPromise);
      } else {
        const promise = new Promise((resolve, reject) => {
          pendingResolvers.set(key, { resolve, reject });
        });
        promiseCache.set(key, promise);
        promises.push(promise);
        requestQueue.push(param);
      }
    }
    if (requestQueue.length > 0) {
      debouncedRequest();
    }
    const results = await Promise.all(promises);
    return {
      code: "100000",
      message: "\u64CD\u4F5C\u6210\u529F",
      status: true,
      data: results
    };
  };
}
export { createBatchRequestWithCache };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/createBatchRequestWithCache.js